import { ErrorHandler } from "@angular/core";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import Swal from "sweetalert2";

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  public oRouter: Router;
  constructor(router: Router) {
    this.oRouter = router;
  }

  handleError(error: any) {
    const url = this.oRouter.url;
    console.error("ErrorHandler: url=" + url);
    console.error(error);
  
    // Si viene como función tipo "() => new Error(...)"
    if (typeof error === 'function') {
      error = error(); // ejecutamos el factory y obtenemos el Error real
    }
  
    // Si viene envuelto por Angular en error.rejection
    if (error?.rejection) {
      error = error.rejection;
    }
  
    const message = error?.message || "Error no manejado";
  
    Swal.close();
  
    Swal.fire({
      text: message as any,
      icon: "error",
      confirmButtonText: "Aceptar",
    });
  }

}
